var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dim flex-col"},[_c('div',{staticClass:"safe-area absolute"},[_vm._m(0),_c('div',{on:{"click":_vm.alertConfirm}},[_c('bottom-button',{attrs:{"buttonArray":_vm.buttonArray}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-wrap"},[_c('div',[_c('span',[_vm._v("법인카드 등록 후,")]),_c('span',[_vm._v("선물하기로 시상하세요.")])])])
}]

export { render, staticRenderFns }